import { ContextProvider } from "components/table/timecard/Context";
import { Table } from "components/table/timecard/Table";

const Timecard = () => {
	return (
		<>
			<ContextProvider>
				<Table />
			</ContextProvider>
		</>
	);
};
export { Timecard };
